import PAGE_NAMES from '../page-names';

class TopNavController {
  constructor(
    $scope,
    $state,
    $timeout,
    $rootScope,
    AuthService,
    BoxCaster,
    User,
    ConfirmDialog,
    Account,
    MeetingsService,
    Checkout,
    Order,
    $uibModal,
    $analytics,
    Products,
    $q
  ) {
    'ngInject';

    this.$state = $state;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.AuthService = AuthService;
    this.Products = Products;
    this.BoxCaster = BoxCaster;
    this.User = User;
    this.Account = Account;
    this.ConfirmDialog = ConfirmDialog;
    this.reloadInterval = REFRESH_INTERVAL_MS;
    this.$uibModal = $uibModal;
    this.$analytics = $analytics;
    this.MeetingsService = MeetingsService;
    this.Order = Order;
    this.user = $rootScope.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    const ua = window.navigator.userAgent;
    this.isIE11 = ua.indexOf('Windows ') >= 0 && ua.indexOf('Trident/') >= 0;
    this.onDismissIE11 = () => {
      this.isIE11Hidden = true;
    };

    this.showLoading = false;
    $rootScope.$on('loading:state', (state) => {
      this.showLoading = state;
    });
    $rootScope.$on('user:switchAccount', (evt, a) => this.switchAccount(a));

    // Keep track of state of the account's BoxCasters to show online/warning indicators
    this.checkBoxcasterOnline();

    this.checkForNewOrders();

    this.planName = '';
    if (this.account.isTrialing()) {
      this.Account.getBilling().$promise.then((result) => {
        this.planName = Checkout.stripeBasePlanNameShortFromBillingResult(result);
      });
    }

    if (this.user.can('list', 'upgrades')) {
      this.upgrades = this.Account.getUpgrades();
      this.upgrades.$promise.then(() => {
        // Filter out proposals that were generated via self-service
        this.upgrades = this.upgrades.filter((u) => !u.self_service);
        // Show "eyebrow" in certain situations
        if (this.account.authorized()) {
          if (this.account.contract == 'trial') {
            this.expiresIn = moment(this.account.expires_on).diff(moment(), 'days');
            this.eyebrowReason = 'trial_will_expire';
          } else if (this.account.payment_method == 'activation') {
            this.expiresIn = moment(this.account.expires_on).diff(moment(), 'days');
            if (this.expiresIn < 30) {
              this.eyebrowReason = 'activation_will_expire';
            }
          } else if (
            this.account.payment_status == 'info_requested' ||
            this.account.payment_status == 'declined'
          ) {
            this.eyebrowReason = 'need_payment';
          } else if (this.upgrades && this.upgrades.length && this.user.metadata.alert_upgrade) {
            this.eyebrowReason = 'has_upgrade';
          } else if (this.user.pending_email_update) {
            this.eyebrowReason = 'unverified_email_address';
          } else if (this.user.metadata.alert_upgrade) {
            // Remove the metadata since there are no upgrades to alert about
            delete this.user.metadata.alert_upgrade;
            User.update(
              { metadata: this.user.metadata },
              (user) => {
                $rootScope.user.reloadFromResource(user);
              },
              () => {
                console.error('Error updating user metadata');
              }
            );
          }

          if (this.eyebrowReason) {
            $scope.$emit('show-eyebrow');
          }
        }
      });
    }

    this.viewProposal = () => {
      const hasUpgrade = this.upgrades && this.upgrades.length == 1;
      if (hasUpgrade) {
        $state.go(
          'checkout',
          { pd_did: this.upgrades[0].pandadoc_id, pd_sid: this.upgrades[0].share_id },
          { reload: true }
        );
      } else {
        $state.go('settings.payment');
      }
      $analytics.eventTrack('view-proposal', { category: 'upgrade' });
    };

    this.onContactUs = () => {
      this.MeetingsService.openPreferredMethod();
    };

    this.onCompleteSetup = () => {
      let checkoutURL = window.VUE_DASHBOARD_ROOT + `/checkout`;
      if (this.account.metadata.remote_mix_sign_up === true) {
        checkoutURL += '/remote-mix';
      }
      window.location.href = checkoutURL;
    };

    this.hideEyebrow = () => {
      this.eyebrowReason = null;
      $scope.$emit('hide-eyebrow');
      delete this.user.metadata.alert_upgrade;
      User.update(
        { metadata: this.user.metadata },
        (user) => {
          $rootScope.user.reloadFromResource(user);
        },
        () => {
          console.error('Error updating user metadata');
        }
      );
      $analytics.eventTrack('hide-eyebrow', { category: 'upgrade' });
    };

    // Need to watch this because it changes as user navigates
    $scope.$watch(
      () => $state.current.name,
      (name) => {
        this.currentState = name;
        this.currentPageTitle = PAGE_NAMES[name];
      }
    );

    // Always let clicks of document not on the exact opener close it
    $(document).click((e) => {
      const TARGET_ID = 'topnav-user-dropdown';

      // Assume the user has clicked elsewhere and we'll be closing the dropdown.
      let isDropdownOpen = false;

      // Any click on the topnav user dropdown (or any of its children) means toggle state; so go
      // looking at the click target to see if it's the dropdown or any of its children.
      let target = e.target;
      while (target) {
        if (target.id == TARGET_ID) {
          isDropdownOpen = !this.isDropdownOpen;
          break;
        }
        target = target.parentNode;
      }

      // Toggle it async
      $scope.$evalAsync(() => (this.isDropdownOpen = isDropdownOpen));
    });
  }

  switchAccount(a) {
    const { ConfirmDialog, User } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Switch Account',
      actionButtonClass: 'primary',
      headerText: 'Confirm Account Switch',
      bodyText: `Your user will be moved to the ${a.name} account.  All other logged in sessions for your user (including on other devices) will be affected.`,
    };

    ConfirmDialog.show(modalOptions).then(() => {
      User.switchAccount({ accountId: a.id }).$promise.then(() => {
        window.location.reload();
      });
    });
  }

  checkBoxcasterOnline() {
    const { BoxCaster, $rootScope, $timeout } = this;

    let boxcasters = BoxCaster.query(
      { l: 1000 },
      () => {
        $rootScope.boxcasters = boxcasters;
        $rootScope.$broadcast('data:boxcasters', boxcasters);
        this.boxcastersOnline = _.reduce(
          boxcasters,
          (total, box) => {
            return box.status == 'offline' ? total : total + 1;
          },
          0
        );
        this.boxcastersNeedAttention = _.reduce(
          boxcasters,
          (total, box) => {
            // TODO: also consider if box is offline but should be broadcasting; not that
            // offline by itself is a normal state
            return box.firmware_status != 'current' ? total + 1 : total;
          },
          0
        );
        this.reloadInterval = REFRESH_INTERVAL_MS;
        $timeout(() => this.checkBoxcasterOnline(), this.reloadInterval);
      },
      (error) => {
        this.reloadInterval = Math.min(2 * this.reloadInterval, 120000); //exponential backoff up to 2min
        $timeout(() => this.checkBoxcasterOnline(), this.reloadInterval);
      }
    );
  }

  toggleNav() {
    const $container = $('left-navbar').parent();
    $container.toggleClass('nav-open');

    // Disable touch scroll bubbling to background
    if ($container.hasClass('nav-open')) {
      $('body').css({ overflow: 'hidden' });
    } else {
      $('body').css({ overflow: 'auto' });
    }
  }

  checkForNewOrders() {
    this.hasOrder = false;
    if (!this.account.metadata.has_new_order) {
      return;
    }
    this.Order.query().$promise.then((result) => {
      let isOutdated = false;
      let filtered = _.filter(result, (o) => o.status != 'cancelled');
      if (filtered.length > 0) {
        this.hasOrder = true;
        this.Order.query({ id: filtered[0].id }).$promise.then((result) => {
          isOutdated =
            this.order.ship_date &&
            Date.now() >
              moment(this.order.ship_date).add(this.order.is_international ? 21 : 14, 'days');
        });
      }

      if (!this.order || isOutdated) {
        delete this.account.metadata.has_new_order;
        this.Account.update(
          { metadata: this.account.metadata },
          (account) => {
            this.$rootScope.account = account;
          },
          () => {
            console.error('Error updating account metadata');
          }
        );
        this.hasOrder = false;
      }
    });
  }

  openOrderStatus() {
    this.$uibModal.open({
      template: require('../settings/modal-order-status.html'),
      resolve: {
        order: () => this.order,
        account: () => this.account,
        showOrdersLink: () => true,
      },
      controller: require('../settings/modal-order-status').default,
      controllerAs: 'vm',
    });
    this.$analytics.eventTrack(`order-status-modal`, { category: 'open', label: '' });
  }

  logout() {
    this.$state.go('logout');
  }
}

export default TopNavController;



// WEBPACK FOOTER //
// ./app/pages/navbar/top-navbar.js